import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import html2canvas from "html2canvas";
import * as htmlToImage from "html-to-image";

import Drawer from "../../components/Drawer";
import Indicators from "./Indicators/Indicators";
import Rankings from "./Rankings/Rankings";
import Options from "./Options/Options";
import DetailedReport from "./DetailedReport/DetailedReport";
import Dealing from "./Dealing/Dealing";
import Dashboard from "./Dashboard/Dashboard";
import Comparisons from "./Comparisons/Comparisons";
import html2pdf from "html2pdf.js";
import {
  Bar,
  Line,
  XAxis,
  YAxis,
  ResponsiveContainer,
  CartesianGrid,
  Tooltip,
  Legend,
  Area,
  ComposedChart,
} from "recharts";

import {
  getCsatQuest,
  getCsatQuestV2,
  getMidias,
  getNpsQuest,
  getNpsQuestV2,
  getRankingAdhesion,
  getRankingCompletedDeal,
  getRankingCsat,
  getRankingSubqualifiers,
  getSentNegotiations,
  getSentNpsCsat,
  getSentSurveys,
  getSlaTickets,
  getUnityTableContent,
  indicatorsGeneral,
  indicatorsGeneralPdf,
} from "../../services/nps/functions";

import { ReactComponent as PrintIcon } from "../../build/images/nps-dashboard-icons/print.svg";
import { ReactComponent as FilterAltIcon } from "../../build/images/nps-dashboard-icons/filter-alt.svg";
import { ReactComponent as ChartIcon } from "../../build/images/nps-dashboard-icons/chart.svg";
import { ReactComponent as GoalIcon } from "../../build/images/nps-dashboard-icons/goal.svg";
import { ReactComponent as SearchCheckNewIcon } from "../../build/images/nps-dashboard-icons/search-check-new.svg";
import { ReactComponent as CheckNewIcon } from "../../build/images/nps-dashboard-icons/check-new.svg";
import { ReactComponent as AccessionIcon } from "../../build/images/nps-dashboard-icons/accession.svg";
import { ReactComponent as SpeedometerNewIcon } from "../../build/images/nps-dashboard-icons/speedometer-new-icon.svg";
import { ReactComponent as HappyNewIcon } from "../../build/images/nps-dashboard-icons/happy-new-icon.svg";
import { ReactComponent as InNegotiationIcon } from "../../build/images/nps-dashboard-icons/in-negotiation-icon.svg";
import { ReactComponent as CalendarNegotiationNewIcon } from "../../build/images/nps-dashboard-icons/calendar-negotiation-new-icon.svg";
import { ReactComponent as InNegotiationIconBlue } from "../../build/images/nps-dashboard-icons/in-negotiation-icon-blue.svg";
import { ReactComponent as CheckNewIconBlue } from "../../build/images/nps-dashboard-icons/check-new-blue.svg";
import { ReactComponent as AccessionIconBlue } from "../../build/images/nps-dashboard-icons/accession-blue.svg";
import { ReactComponent as CalendarNegotiationNewIconBlue } from "../../build/images/nps-dashboard-icons/calendar-negotiation-new-icon-blue.svg";
import { ReactComponent as ArrowUpIcon } from "../../build/images/nps-dashboard-icons/arrow-up-pdf.svg";
import { ReactComponent as ArrowDownIcon } from "../../build/images/nps-dashboard-icons/arrow-down-pdf.svg";
import { ReactComponent as IconPdf } from "../../build/images/nps-dashboard-icons/pdf-new-icon.svg";
import { ReactComponent as ColumnFilterIcon } from "../../build/images/icons/ColumnFilterIcon.svg";
import { ReactComponent as MenuIcon } from "../../build/images/icons/new-three-dots-menu.svg";
import { ReactComponent as SettingsIcon } from "../../build/images/setting-2.svg";

import defaultLogo from "../../build/images/nps-dashboard-icons/default-new-logo.svg";
import defaultCoverLogo from "../../build/images/nps-dashboard-icons/default-new-cover-logo.svg";

import "./nps-page.css";
import Typography from "../Typography";
import { useLocalStorage } from "./hooks/useLocalStorage";
import { connection_platform } from "../../services/api";
import Loading from "../Loading";
import HorizontalStackedChart from "./HorizontalStackedChart";
import MicroModal from "micromodal";
import ModalGeneratePdf from "./ModalGeneratePdf";
import {
  compareAsc,
  format,
  getDate,
  isAfter,
  lastDayOfMonth,
  parseISO,
  startOfMonth,
  subMonths,
} from "date-fns";
import { reduceString } from "../../utils/reduceString";
import { groupBy } from "../../utils/groupBy";
import DashboardAgent from "./DashboardAgent/DashboardAgent";
import PopoverColumnsFilter from "../popovercolumnsfilter/PopoverColumnsFilter";
//import PopoverDashFilter from "../PopoverDashFilter";

let exhibCards = [];
let exhibIndicatorsCards = [];

const QualityAgent = () => {
  const userReducer = useSelector((state) => state.informationusers);
  const filtersDashboard = useSelector((state) => state.npsfilters);
  const agentDashboardFilter = useSelector(
    (state) => state.agentDashboardFilter,
  );
  const cardsOfCallCenterDash = useSelector(
    (state) => state.cardsOfCallCenterDash,
  );
  const cardsOfCallCenterIndicators = useSelector(
    (state) => state.cardsOfCallCenterIndicators,
  );
  const buttonData = [
    {
      componentName: "DashboardAgent",
      icon: <ChartIcon />,
      text: "Dashboard",
    },
    {
      componentName: "IndicatorsAgent",
      icon: <div className="alternative-icon" />,
      text: "Indicadores",
    },
    {
      componentName: "RankingAgent",
      icon: <div className="alternative-icon" />,
      text: "Ranking",
    },
  ];

  if (userReducer.evaluation_feedback) {
    buttonData.push({
      componentName: "DealingAgent",
      icon: <div className="alternative-icon" />,
      text: "Tratativas",
    });
  }

  /*
  if (userReducer.evaluation_feedback) {
    buttonData.push({
      componentName: "Dealing",
      icon: <div className="alternative-icon" />,
      text: "Tratativas",
    });
  }
    */

  const [activeButton, setActiveButton] = useState("DashboardAgent");
  const [filters, setFilters] = useState(false);
  const [type, setType] = useState(1);
  const [metaValue, setMetaValue] = useState(getMetaValue());
  const [startDate, setStartDate] = useState(
    agentDashboardFilter.initialDateAgenteScreen,
  );
  const [endDate, setEndDate] = useState(
    agentDashboardFilter.finalDateAgentScreen,
  );
  const [unitsSelected, setUnitsSelected] = useState(filtersDashboard.units);
  const [businessSelected, setBusinessSelected] = useState(
    filtersDashboard.business,
  );
  const [currentMonthStart, setCurrentMonthStart] = useState("10/06/2024");
  const [lastMonthStart, setLastMonthStart] = useState("10/06/2024");
  const [currentMonthEnd, setCurrentMonthEnd] = useState("10/06/2024");
  const [lastMonthEnd, setLastMonthEnd] = useState("10/06/2024");
  const [units, setUnits] = useState("Todas");
  const [areaColors, setAreaColors] = useState({
    good: { color: "#008908", topRangeInHours: null, bottomRangeInHours: 96 },
    medium: { color: "#F2BD00", topRangeInHours: 96, bottomRangeInHours: 132 },
    bad: { color: "#C90000", topRangeInHours: 132, bottomRangeInHours: null },
  });
  const [dataEvo, setDataEvo] = useState([]);
  const [dataEvoCsat, setDataEvoCsat] = useState([]);
  const [dataEvoCsatTreated, setDataEvoCsatTreated] = useState([]);
  const [surveyInfos, setSurveyInfos] = useState({
    enviadas: "0",
    respondidas: 0,
    clientes: 0,
    porcentagemClientes: 0,
    tempMedio: "0",
  });
  const [surveyInfosSecondLine, setSurveyInfosSecondLine] = useState({
    npsQtde: 0,
    csatQtde: 0,
    npsTrend: 0,
  });
  const [surveyNegotiationsInfos, setSurveyNegotiationsInfos] = useState({
    inNegotiation: 0,
    inNegotiationDif: 0,
    treated: 0,
    treatedDif: 0,
    percent: 0,
    percentDif: 0,
    average: 0,
    averageDif: 0,
  });
  const [surveyNegotiationsInfosLast, setSurveyNegotiationsInfosLast] =
    useState({
      inNegotiation: 0,
      treated: 0,
      percent: 0,
      average: 0,
    });
  const [stackedDataTreatment, setStackedDataTreatment] = useState({
    good: 0,
    bad: 0,
    total: 0,
    goodPercent: 0,
    badPercent: 0,
  });
  const [subqualifiersTreatment, setSubqualifiersTreatment] = useState([]);
  const [stackedDataStructure, setStackedDataStructure] = useState({
    good: 0,
    bad: 0,
    total: 0,
    goodPercent: 0,
    badPercent: 0,
  });
  const [subqualifiersStructure, setSubqualifiersStructure] = useState([]);
  const [stackedDataService, setStackedDataService] = useState({
    good: 0,
    bad: 0,
    total: 0,
    goodPercent: 0,
    badPercent: 0,
  });
  const [subqualifiersService, setSubqualifiersService] = useState([]);
  const [profile, setProfile] = useState("");
  const [subqualifierType, setSubqualifierType] = useState("");
  const [caseTypeLabel, setCaseTypeLabel] = useState("");
  const [npsGoal, setNpsGoal] = useState(getMetaValue());
  const [loadingCount, setLoadingCount] = useState(
    "Realizando requisições para geração do relatório",
  );

  const npsEvolutionRef = useRef(null);
  const loadingPdf = useRef(null);
  const toGeneratePdf = useRef(null);
  const casesComplaintRef = useRef(null);
  const casesRef = useRef(null);
  const rankingNpsRef = useRef(null);
  const rankingCsatRef = useRef(null);
  const rankingAccessionRef = useRef(null);
  const rankingSubqualifierRef = useRef(null);
  const rankingCompletedNegotiationsRef = useRef(null);
  const rankingMediumTermRef = useRef(null);
  const pdfPage1 = useRef(null);
  const pdfPage2 = useRef(null);
  const pdfPage3 = useRef(null);
  const pdfPage4 = useRef(null);
  const pdfPage5 = useRef(null);
  const coverRef = useRef(null);
  const generalAnalysisNpsRef = useRef(null);
  const generalAnalysisCsatRef = useRef(null);
  const subqualifiersPageRef = useRef(null);
  const negotiationsRef = useRef(null);
  const rankingNpsContainerRef = useRef(null);
  const casesContainerRef = useRef(null);
  const casesComplaintContainerRef = useRef(null);
  const rankingCsatContainerRef = useRef(null);
  const rankingAccessionContainerRef = useRef(null);
  const rankingSubqualifierContainerRef = useRef(null);
  const rankingCompletedNegotiationsContainerRef = useRef(null);
  const rankingMediumTermContainerRef = useRef(null);

  const hasUnits = !!unitsSelected && unitsSelected.length > 0;
  const isDashboardScreen = activeButton === "DashboardAgent";
  const isIndicatorsScreen = activeButton === "IndicatorsAgent";
  const hasFiltersOfGraphics = isDashboardScreen || isIndicatorsScreen;

  const lastNegotitations = [
    {
      id: "inNegotiationLast",
      icon: <InNegotiationIconBlue />,
      number: surveyNegotiationsInfosLast.inNegotiation,
      information: "Manifestações em tratativas",
      class: "inNegotiationLast",
    },
    {
      id: "treatedLast",
      icon: <CheckNewIconBlue />,
      number: surveyNegotiationsInfosLast.treated,
      information: "Manifestações tratadas",
      class: "treatedLast",
    },
    {
      id: "percentCompletedLast",
      icon: <AccessionIconBlue />,
      number: `${surveyNegotiationsInfosLast.percent.toFixed(2)}%`,
      information: "% de tratativas concluídas",
      class: "percentCompletedLast",
    },
    {
      id: "averageNegotiationPeriodLast",
      icon: <CalendarNegotiationNewIconBlue />,
      number: surveyNegotiationsInfosLast.average,
      information: "Prazo médio de tratativas",
      class: "averageNegotiationPeriodLast",
    },
  ];

  const currentNegotiations = [
    {
      id: "inNegotiation",
      icon: <InNegotiationIcon />,
      number: surveyNegotiationsInfos.inNegotiation,
      information: "Manifestações em tratativas",
      difference: surveyNegotiationsInfos.inNegotiationDif,
      class: "inNegotiation",
    },
    {
      id: "treated",
      icon: <CheckNewIcon />,
      number: surveyNegotiationsInfos.treated,
      information: "Manifestações tratadas",
      difference: surveyNegotiationsInfos.treatedDif,
      class: "treated",
    },
    {
      id: "percentCompleted",
      icon: <AccessionIcon />,
      number: `${surveyNegotiationsInfos.percent.toFixed(2)}%`,
      information: "% de tratativas concluídas",
      difference: surveyNegotiationsInfos.percentDif,
      class: "percentCompleted",
    },
    {
      id: "averageNegotiationPeriod",
      icon: <CalendarNegotiationNewIcon />,
      number: surveyNegotiationsInfos.average,
      information: "Prazo médio de tratativas",
      difference: surveyNegotiationsInfos.averageDif,
      class: "averageNegotiationPeriod",
    },
  ];

  const surveyData = [
    {
      icon: <SearchCheckNewIcon />,
      number: surveyInfos.enviadas,
      information: "Pesquisas enviadas",
      classContainer: "line1",
      class: "sent-surveys",
    },
    {
      icon: <CheckNewIcon />,
      number: surveyInfos.clientes,
      information: "Respondidas",
      classContainer: "line1",
      class: "customers-responded-survey",
    },
    {
      icon: <AccessionIcon />,
      number: surveyInfos.porcentagemClientes,
      information: "% de adesão",
      classContainer: "line1",
      class: "customer-percentage",
    },
    {
      icon: <SpeedometerNewIcon />,
      number: surveyInfosSecondLine.npsQtde,
      information: "NPS",
      classContainer: "line2",
      class: "customers-nps",
    },
    {
      icon: <HappyNewIcon />,
      number: surveyInfosSecondLine.csatQtde,
      information: "CSAT",
      classContainer: "line2",
      class: "customers-responded-survey",
    },
    {
      icon: <HappyNewIcon />,
      number: surveyInfosSecondLine.npsTrend,
      information: "Tendência de NPS",
      classContainer: "line2",
      class: "customers-nps-tendency",
    },
  ];

  exhibCards = [
    {
      title: "Evolução do NPS",
      exhib: cardsOfCallCenterDash.card1,
    },
    {
      title: "Notas do NPS",
      exhib: cardsOfCallCenterDash.card2,
    },
    {
      title: "Resumo",
      exhib: cardsOfCallCenterDash.card3,
    },
    {
      title: "Avaliação por canal",
      exhib: cardsOfCallCenterDash.card4,
    },
    {
      title: "Perfis",
      exhib: cardsOfCallCenterDash.card5,
    },
    {
      title: "Pesquisas",
      exhib: cardsOfCallCenterDash.card6,
    },
    {
      title: "Taxa de compilação",
      exhib: cardsOfCallCenterDash.card7,
    },
    {
      title: "Mapa de humor",
      exhib: cardsOfCallCenterDash.card8,
    },
    {
      title: "CSAT do período",
      exhib: cardsOfCallCenterDash.card9,
    },
    {
      title: "CSAT por canal",
      exhib: cardsOfCallCenterDash.card10,
    },
    {
      title: "CSAT deste mês",
      exhib: cardsOfCallCenterDash.card11,
    },
    {
      title: "CSAT por canal (gráfico)",
      exhib: cardsOfCallCenterDash.card12,
    },
    {
      title: "NPS e CSAT por agente",
      exhib: cardsOfCallCenterDash.card13,
    },
  ];

  exhibIndicatorsCards = [
    {
      title: "Pesquisas",
      exhib: cardsOfCallCenterIndicators.card1,
    },
    {
      title: "NPS",
      exhib: cardsOfCallCenterIndicators.card2,
    },
    {
      title: "Média de notas",
      exhib: cardsOfCallCenterIndicators.card3,
    },
    {
      title: "Engajamento",
      exhib: cardsOfCallCenterIndicators.card4,
    },
    {
      title: "Perfil",
      exhib: cardsOfCallCenterIndicators.card5,
    },
    {
      title: "Pesquisas enviadas x respondidas",
      exhib: cardsOfCallCenterIndicators.card6,
    },
    {
      title: "Quantidade de participantes por perfil",
      exhib: cardsOfCallCenterIndicators.card7,
    },
  ];

  function getMetaValue() {
    const [storedValue, setStoredValue] = useLocalStorage("ingWebNPS_goal", 0);
    let goal = 0;
    if (storedValue) {
      goal = storedValue;
    }
    return goal;
  }

  const handleButtonClick = (componentName) => {
    setActiveButton(componentName);
  };

  const handleWeek = (weekDay) => {
    switch (weekDay) {
      case 0:
        return "Domingo";
      case 1:
        return "Segunda";
      case 2:
        return "Terça";
      case 3:
        return "Quarta";
      case 4:
        return "Quinta";
      case 5:
        return "Sexta";
      case 6:
        return "Sábado";

      default:
        break;
    }
  };

  const handleTime = (time) => {
    if (type === 1) {
      const timestamp = Date.parse(time);
      if (!isNaN(timestamp) && typeof time !== "number") {
        // const newTime = time.replaceAll("-", "/");
        // return format(new Date(newTime), "MM/yyyy", {
        //   locale: ptBR,
        // });
        // o codigo acima não funciona no safari
        let t1 = time.split("-");
        return `${t1[1]}/${t1[0]}`;
      } else {
        return time;
      }
    } else if (type === 2) {
      return handleWeek(time);
    } else {
      return `${time}:00`;
    }
  };

  const CustomYAxisTick = ({ x, y, payload }) => {
    return (
      <g transform={`translate(${20},${y + 4})`}>
        <text
          x={0}
          y={0}
          textAnchor="start"
          fill="rgba(0, 0, 0, 0.38)"
          style={{ fontFamily: "Inter", fontSize: 12 }}
        >
          {payload.value}%
        </text>
      </g>
    );
  };

  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      let t1 = "00-00";
      if (type !== 2 && type !== 3) {
        t1 = payload[0].payload.name.split("-");
      }
      return (
        <div className="custom-tooltip">
          <p className="label">
            {type === 2
              ? handleWeek(payload[0].payload.name)
              : type === 3
                ? `${payload[0].payload.name}:00`
                : // : format(
                  //     new Date(payload[0].payload.name.replaceAll("-", "/")),
                  //     "MM/yyyy",
                  //     {
                  //       locale: ptBR,
                  //     }
                  //   )}
                  // o codigo acima nao funciona no safari
                  `${t1[1]}/${t1[0]}`}
          </p>
          <Typography.H5 weight="400" color="gray-180">
            NPS Original: {payload[0].payload.npsO}%
          </Typography.H5>
          <Typography.H5 weight="400" color="gray-180">
            Meta: {payload[0].payload.meta}%
          </Typography.H5>
        </div>
      );
    }

    return null;
  };

  async function getTableDataNps(
    formatedInitialDate,
    formatedFinalDate,
    unitsIds,
    businessId,
    goal,
  ) {
    let dataToGenerateTableRankingNps = null;

    const rankingNpsData = await getUnityTableContent(
      formatedInitialDate,
      formatedFinalDate,
      unitsIds,
      businessId,
    );

    const hasRankingNpsData = rankingNpsData && rankingNpsData.length;
    if (hasRankingNpsData) {
      dataToGenerateTableRankingNps = rankingNpsData.map((npsData) => {
        const promoterQtd = npsData.promotor ? npsData.promotor : 0;
        const detractorQtd = npsData.detrator ? npsData.detrator : 0;
        const neutralQtd = npsData.neutro ? npsData.neutro : 0;
        const totalToCalcNps = promoterQtd + detractorQtd + neutralQtd;
        const calcNps = totalToCalcNps
          ? (((promoterQtd - detractorQtd) / totalToCalcNps) * 100).toFixed(2)
          : "0.00";
        const percentage = npsData.qtde_envio
          ? ((npsData.qtde_avaliada / npsData.qtde_envio) * 100).toFixed(0) +
            "%"
          : "";
        const rawNps = totalToCalcNps
          ? ((promoterQtd - detractorQtd) / totalToCalcNps) * 100
          : 0;

        return {
          Unidade: npsData.unidade ? npsData.unidade : "",
          Ranking: {
            promoter: promoterQtd,
            detrator: detractorQtd,
            neutral: neutralQtd,
            total: totalToCalcNps,
            colorPromoter: "#008908",
            colorDetrator: "#C90000",
            colorNeutral: "#F2BD00",
          },
          Nota: `${calcNps} NPS`,
          Qtd: npsData.qtde ? npsData.qtde : 0,
          "%": percentage,
          goal,
          rawNps,
        };
      });
    }

    const hasDataToGenerateTableRankingNps =
      !!dataToGenerateTableRankingNps &&
      dataToGenerateTableRankingNps.length > 0;
    if (hasDataToGenerateTableRankingNps) {
      dataToGenerateTableRankingNps.sort((a, b) => {
        const isBAndAEqual = b.rawNps === a.rawNps;
        if (isBAndAEqual) {
          const bQtd = Number(b.Qtd) ? Number(b.Qtd) : 0;
          const aQtd = Number(a.Qtd) ? Number(a.Qtd) : 0;
          return bQtd - aQtd;
        }

        return b.rawNps - a.rawNps;
      });
    }
    return dataToGenerateTableRankingNps;
  }

  async function getTableDataCsat(
    formatedInitialDate,
    formatedFinalDate,
    unitsIds,
    businessId,
    goal,
  ) {
    let dataToGenerateRankingCsatTable = null;
    const response = await getRankingCsat(
      formatedInitialDate,
      formatedFinalDate,
      unitsIds,
      businessId,
    );
    const hasResponse = !!response && response.status === 200;
    if (hasResponse) {
      const dataRankingCsat = response.data;
      const hasDataRankingCsat =
        !!dataRankingCsat && dataRankingCsat.length > 0;
      if (hasDataRankingCsat) {
        dataToGenerateRankingCsatTable = dataRankingCsat.map((csatInfo) => {
          const numberScore = Number(csatInfo.nota);
          let complete = 0;
          let score = 0;
          const isNumberScoreANumber = !!numberScore || numberScore === 0;
          if (isNumberScoreANumber) {
            complete = numberScore;
            score = numberScore;
          }

          const numberQtdeSent = Number(csatInfo.qtde_envio);
          let qtdSent = 0;
          const isNumberQtdeANumber = !!numberQtdeSent || numberQtdeSent === 0;
          if (isNumberQtdeANumber) {
            qtdSent = numberQtdeSent;
          }

          const numberQtdeAnswered = Number(csatInfo.qtde_avaliada);
          let qtdAnswered = 0;
          const isNumberQtdeAnsweredANumber =
            !!numberQtdeAnswered || numberQtdeAnswered === 0;
          if (isNumberQtdeAnsweredANumber) {
            qtdAnswered = numberQtdeAnswered;
          }
          const percent = qtdSent
            ? `${(qtdAnswered / qtdSent).toFixed(2)}%`
            : "0%";

          return {
            Unidade: csatInfo.unidade,
            Ranking: {
              complete: complete,
              incomplete: 100 - complete,
              total: 100,
              colorComplete: "#008908",
              colorIncomplete: "#C90000",
            },
            Nota: `${score} CSAT`,
            Qtd: csatInfo.qtde,
            "%": percent,
            goal,
            rawCsat: score,
          };
        });
      }

      const hasDataToGenerateRankingCsatTable =
        !!dataToGenerateRankingCsatTable &&
        dataToGenerateRankingCsatTable.length > 0;
      if (hasDataToGenerateRankingCsatTable) {
        dataToGenerateRankingCsatTable.sort((a, b) => {
          const isBAndAEqual = b.rawCsat === a.rawCsat;
          if (isBAndAEqual) {
            const bQtd = Number(b.Qtd) ? Number(b.Qtd) : 0;
            const aQtd = Number(a.Qtd) ? Number(a.Qtd) : 0;
            return bQtd - aQtd;
          }

          return b.rawCsat - a.rawCsat;
        });
      }

      return dataToGenerateRankingCsatTable;
    } else {
      return dataToGenerateRankingCsatTable;
    }
  }

  async function updateSurveyInfo(
    formatedInitialDate,
    formatedFinalDate,
    unitsIds,
    businessId,
  ) {
    const response = await getSentSurveys(
      formatedInitialDate,
      formatedFinalDate,
      businessId,
      unitsIds,
    );

    if (response && response.status === 200) {
      const data = response.data;
      const newSurveyData = data.map((datum) => ({
        enviadas: datum.qtde_enviada,
        respondidas: datum.qtde_respondida,
        clientes: datum.qtde_respondida,
        porcentagemClientes:
          Number(datum.qtde_enviada) > 0
            ? ((datum.qtde_respondida / datum.qtde_enviada) * 100).toFixed(2)
            : 0,
        tempMedio: datum.media_resposta_pesquisa
          ? handleTempMed(datum.media_resposta_pesquisa)
          : "0",
      }));

      setSurveyInfos(newSurveyData[0]);
    } else {
      setSurveyInfos({
        enviadas: "0",
        respondidas: 0,
        clientes: 0,
        porcentagemClientes: 0,
        tempMedio: "0",
      });
    }
  }

  function calcDiffDays(formatedInitialDate, formatedFinalDate) {
    const dateInit = new Date(formatedInitialDate);
    const dateEnd = new Date(formatedFinalDate);
    const timeDiff = Math.abs(dateEnd.getTime() - dateInit.getTime());
    const diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));

    return diffDays;
  }

  function getDateOfMonthsAgo(finalDate, numberOfMonths) {
    const date = parseISO(finalDate);
    const monthsAgo = subMonths(date, numberOfMonths);
    const firstDayOfMonthsAgo = startOfMonth(monthsAgo);

    return format(firstDayOfMonthsAgo, "yyyy-MM-dd");
  }

  async function getDataEvo(
    formatedInitialDate,
    formatedFinalDate,
    unitsIds,
    businessId,
    goal = metaValue,
    numberOfMonthsAgo,
  ) {
    const rawDateInit = getDateOfMonthsAgo(
      formatedInitialDate,
      numberOfMonthsAgo,
    );
    const dateInit = new Date(rawDateInit);
    const dateEnd = new Date(formatedFinalDate);
    const diffDays = calcDiffDays(formatedInitialDate, formatedFinalDate);
    let typeApi = 1;

    if (dateInit.toDateString() === dateEnd.toDateString()) {
      typeApi = 3;
    } else if (diffDays > 0 && diffDays < 30) {
      typeApi = 2;
    } else if (diffDays >= 30) {
      typeApi = 1;
    }

    let dataToGenerateGraph = [];

    const response = await getNpsQuestV2(
      rawDateInit,
      formatedFinalDate,
      businessId,
      unitsIds,
      1,
    );

    const hasResponse = !!response && response.status === 200;
    if (hasResponse) {
      const results = response.data;
      const hasResults = !!results && results.length > 0;
      if (hasResults) {
        const groupedByDateResults = groupBy(results, "data_nps");
        const hasGroupedByDateResults = !!groupedByDateResults;

        if (hasGroupedByDateResults) {
          for (let keyName in groupedByDateResults) {
            const name = keyName;
            let npsO = 0;
            let npsT = 0;
            const arrWithData = groupedByDateResults[keyName];
            const hasArrWithData = !!arrWithData && arrWithData.length > 0;
            if (hasArrWithData) {
              arrWithData.forEach((data) => {
                const isOriginalData = !!data.resultado;
                const isTreatedData = !!data.resultado_tratativa;
                if (isOriginalData) {
                  npsO = data.resultado;
                } else if (isTreatedData) {
                  npsT = data.resultado_tratativa;
                }
              });
            }

            dataToGenerateGraph.push({
              name,
              npsO,
              npsT,
              meta: goal,
            });
          }
        }
      }
    }

    setDataEvo(dataToGenerateGraph);
  }

  async function getDataEvoCsat(
    formatedInitialDate,
    formatedFinalDate,
    unitsIds,
    businessId,
    goal = metaValue,
    numberOfMonthsAgo,
  ) {
    const rawDateInit = getDateOfMonthsAgo(
      formatedInitialDate,
      numberOfMonthsAgo,
    );
    const dateInit = new Date(rawDateInit);
    const dateEnd = new Date(formatedFinalDate);
    const diffDays = calcDiffDays(formatedInitialDate, formatedFinalDate);
    let typeApi = 1;

    if (dateInit.toDateString() === dateEnd.toDateString()) {
      typeApi = 3;
    } else if (diffDays > 0 && diffDays < 30) {
      typeApi = 2;
    } else if (diffDays >= 30) {
      typeApi = 1;
    }

    let dataToGenerateGraph = [];

    const response = await getCsatQuestV2(
      rawDateInit,
      formatedFinalDate,
      businessId,
      unitsIds,
      1,
    );

    const hasResponse = !!response && response.status === 200;
    if (hasResponse) {
      const results = response.data;
      const hasResults = !!results && results.length > 0;
      if (hasResults) {
        const groupedByDateResults = groupBy(results, "data_csat");
        const hasGroupedByDateResults = !!groupedByDateResults;

        if (hasGroupedByDateResults) {
          for (let keyName in groupedByDateResults) {
            const name = keyName;
            let npsO = 0;
            let npsT = 0;
            const arrWithData = groupedByDateResults[keyName];
            const hasArrWithData = !!arrWithData && arrWithData.length > 0;
            if (hasArrWithData) {
              arrWithData.forEach((data) => {
                const isOriginalData = !!data.resultado;
                const isTreatedData = !!data.resultado_tratativa;
                if (isOriginalData) {
                  npsO = data.resultado;
                } else if (isTreatedData) {
                  npsT = data.resultado_tratativa;
                }
              });
            }

            dataToGenerateGraph.push({
              name,
              npsO,
              npsT,
              meta: goal,
            });
          }
        }
      }
    }

    setDataEvoCsat(dataToGenerateGraph);
  }

  async function getIndicatorsInfoV2(
    formatedInitialDate,
    formatedFinalDate,
    unitsIds,
    businessId,
    questionsNPS,
    questionsCSAT,
    channels,
  ) {
    const response = await indicatorsGeneralPdf(
      formatedInitialDate,
      formatedFinalDate,
      unitsIds,
      businessId,
      questionsNPS,
      questionsCSAT,
      channels,
    );

    const hasResponse = !!response && response.status === 200;
    if (hasResponse) {
      let updatedStackedDataTreatment = {
        good: 0,
        bad: 0,
        total: 0,
        goodPercent: 0,
        badPercent: 0,
      };
      let updatedSubqualifiersTreatment = [];
      let updatedStackedDataStructure = {
        good: 0,
        bad: 0,
        total: 0,
        goodPercent: 0,
        badPercent: 0,
      };
      let updatedSubqualifiersStructure = [];
      let updatedStackedDataService = {
        good: 0,
        bad: 0,
        total: 0,
        goodPercent: 0,
        badPercent: 0,
      };
      let updatedSubqualifiersService = [];

      const dataIndicators = response.data;
      const hasData = !!dataIndicators && dataIndicators.length > 0;
      if (hasData) {
        const treatmentIndicator = dataIndicators.find(
          (indicator) =>
            indicator.pergunta === "Atendimento" ||
            indicator.pergunta === "atendimento",
        );
        const hasTreatmentIndicator = !!treatmentIndicator;
        if (hasTreatmentIndicator) {
          const resultNumber = Number(treatmentIndicator.resultado);
          let goodPercent = 0;
          let badPercent = 0;
          const isResultNumberANumber = typeof resultNumber === "number";
          if (isResultNumberANumber) {
            goodPercent = resultNumber;
            badPercent = 100 - resultNumber;
          }

          let good = 0;
          let bad = 0;
          try {
            const asnwers = JSON.parse(treatmentIndicator.respostas);
            const hasAnswers = !!asnwers && asnwers.length > 0;
            if (hasAnswers) {
              asnwers.forEach((answer) => {
                const isGood =
                  answer.resposta === "Bom" || answer.resposta === "bom";
                if (isGood) {
                  good = good + answer.qtde;
                } else {
                  bad = bad + answer.qtde;
                }
              });
            }
          } catch (error) {
            console.log("Erro ao realizar o PARSE: ", error);
          }
          let total = good + bad;

          updatedStackedDataTreatment = {
            good,
            bad,
            total,
            goodPercent,
            badPercent,
          };

          let subqualifiers = null;
          try {
            const parsedRawSubqualifiers = JSON.parse(
              treatmentIndicator.subqualificadores,
            );
            subqualifiers = parsedRawSubqualifiers;
          } catch (error) {
            console.log("erro ao realizar o parse: ", error);
          }
          const hasSubqualifiers = !!subqualifiers && subqualifiers.length > 0;
          if (hasSubqualifiers) {
            updatedSubqualifiersTreatment = subqualifiers.map((sub, index) => {
              return {
                label: sub.subqualificador,
                value: sub.qtde,
                id: index,
              };
            });
          }
        }

        const structureIndicator = dataIndicators.find(
          (indicator) =>
            indicator.pergunta === "Estrutura" ||
            indicator.pergunta === "estrutura",
        );
        const hasStructureIndicator = !!structureIndicator;
        if (hasStructureIndicator) {
          const resultNumber = Number(structureIndicator.resultado);
          let goodPercent = 0;
          let badPercent = 0;
          const isResultNumberANumber = typeof resultNumber === "number";
          if (isResultNumberANumber) {
            goodPercent = resultNumber;
            badPercent = 100 - resultNumber;
          }

          let good = 0;
          let bad = 0;
          let total = 0;
          try {
            const asnwers = JSON.parse(structureIndicator.respostas);
            const hasAnswers = !!asnwers && asnwers.length > 0;
            if (hasAnswers) {
              asnwers.forEach((answer) => {
                const isGood =
                  answer.resposta === "Bom" || answer.resposta === "Bom";
                if (isGood) {
                  good = good + answer.qtde;
                } else {
                  bad = bad + answer.qtde;
                }
              });
            }
          } catch (error) {
            console.log("erro ao realizar o parse: ", error);
          }
          total = good + bad;

          updatedStackedDataStructure = {
            good,
            bad,
            total,
            goodPercent,
            badPercent,
          };

          let subqualifiers = null;
          try {
            const parsedRawSubqualifiers = JSON.parse(
              structureIndicator.subqualificadores,
            );
            subqualifiers = parsedRawSubqualifiers;
          } catch (error) {
            console.log("erro ao realizar o parse: ", error);
          }
          const hasSubqualifiers = !!subqualifiers && subqualifiers.length > 0;
          if (hasSubqualifiers) {
            updatedSubqualifiersStructure = subqualifiers.map((sub, index) => {
              return {
                label: sub.subqualificador,
                value: sub.qtde,
                id: index,
              };
            });
          }
        }

        const serviceIndicator = dataIndicators.find(
          (indicator) =>
            indicator.pergunta === "Serviço" ||
            indicator.pergunta === "serviço",
        );
        const hasServiceIndicator = !!serviceIndicator;
        if (hasServiceIndicator) {
          const resultNumber = Number(serviceIndicator.resultado);
          let goodPercent = 0;
          let badPercent = 0;
          const isResultNumberANumber = typeof resultNumber === "number";
          if (isResultNumberANumber) {
            goodPercent = resultNumber;
            badPercent = 100 - resultNumber;
          }

          let good = 0;
          let bad = 0;
          let total = 0;
          try {
            const asnwers = JSON.parse(serviceIndicator.respostas);
            const hasAnswers = !!asnwers && asnwers.length > 0;
            if (hasAnswers) {
              asnwers.forEach((answer) => {
                const isGood =
                  answer.resposta === "Bom" || answer.resposta === "bom";
                if (isGood) {
                  good = good + answer.qtde;
                } else {
                  bad = bad + answer.qtde;
                }
              });
            }
          } catch (error) {
            console.log("erro ao realizar o parse: ", error);
          }
          total = good + bad;

          updatedStackedDataService = {
            good,
            bad,
            total,
            goodPercent,
            badPercent,
          };

          let subqualifiers = null;
          try {
            const parsedRawSubqualifiers = JSON.parse(
              serviceIndicator.subqualificadores,
            );
            subqualifiers = parsedRawSubqualifiers;
          } catch (error) {
            console.log("erro ao realizar o parse: ", error);
          }
          const hasSubqualifiers = !!subqualifiers && subqualifiers.length > 0;
          if (hasSubqualifiers) {
            updatedSubqualifiersService = subqualifiers.map((sub, index) => {
              return {
                label: sub.subqualificador,
                value: sub.qtde,
                id: index,
              };
            });
          }
        }
      }

      const hasUpdatedSubqualifiersTreatment =
        !!updatedSubqualifiersTreatment &&
        updatedSubqualifiersTreatment.length > 0;
      if (hasUpdatedSubqualifiersTreatment) {
        updatedSubqualifiersTreatment.sort((a, b) => b.value - a.value);
      }

      const hasUpdatedSubqualifiersStructure =
        !!updatedSubqualifiersStructure &&
        updatedSubqualifiersStructure.length > 0;
      if (hasUpdatedSubqualifiersStructure) {
        updatedSubqualifiersStructure.sort((a, b) => b.value - a.value);
      }

      const hasUpdatedSubqualifiersService =
        !!updatedSubqualifiersService && updatedSubqualifiersService.length > 0;
      if (hasUpdatedSubqualifiersService) {
        updatedSubqualifiersService.sort((a, b) => b.value - a.value);
      }

      setStackedDataTreatment(updatedStackedDataTreatment);
      setSubqualifiersTreatment(updatedSubqualifiersTreatment);
      setStackedDataStructure(updatedStackedDataStructure);
      setSubqualifiersStructure(updatedSubqualifiersStructure);
      setStackedDataService(updatedStackedDataService);
      setSubqualifiersService(updatedSubqualifiersService);
    } else {
      setStackedDataTreatment({
        good: 0,
        bad: 0,
        total: 0,
        goodPercent: 0,
        badPercent: 0,
      });
      setSubqualifiersTreatment([]);
      setStackedDataStructure({
        good: 0,
        bad: 0,
        total: 0,
        goodPercent: 0,
        badPercent: 0,
      });
      setSubqualifiersStructure([]);
      setStackedDataService({
        good: 0,
        bad: 0,
        total: 0,
        goodPercent: 0,
        badPercent: 0,
      });
      setSubqualifiersService([]);
    }
  }

  function getTemMedInSeconds(stringTemp) {
    const cutTime = stringTemp.split(" ");
    const hasTwoElements =
      !!cutTime && Array.isArray(cutTime) && cutTime.length === 2;
    if (hasTwoElements) {
      const valueTime = Number(cutTime[0]) ? Number(cutTime[0]) : 0;
      const timeType = cutTime[1];

      switch (timeType) {
        case "ano(s)":
          return valueTime * 31536000;
        case "meses":
          return valueTime * 2592000;
        case "mês":
          return valueTime * 2592000;
        case "dia(s)":
          return valueTime * 86400;
        case "hora(s)":
          return valueTime * 3600;
        case "minuto(s)":
          return valueTime * 60;
        case "segundo(s)":
          return valueTime;
        default:
          return 0;
      }
    } else {
      return 0;
    }
  }

  async function getTableDataAccession(
    formatedInitialDate,
    formatedFinalDate,
    unitsIds,
    businessId,
    adhesionGoal,
  ) {
    let updatedTableData = null;
    const response = await getRankingAdhesion(
      formatedInitialDate,
      formatedFinalDate,
      unitsIds,
      businessId,
    );
    const hasResponse = !!response && response.status === 200;
    if (hasResponse) {
      const data = response.data;
      const hasData = !!data && data.length > 0;
      if (hasData) {
        updatedTableData = data.map((adhesionInfo) => {
          const total = Number(adhesionInfo.qtde_envio)
            ? Number(adhesionInfo.qtde_envio)
            : 0;
          const complete = Number(adhesionInfo.qtde_avaliada)
            ? Number(adhesionInfo.qtde_avaliada)
            : 0;
          const incomplete = total - complete;
          const percent = total ? ((complete / total) * 100).toFixed(2) : 0;

          return {
            Unidade: adhesionInfo.unidade,
            Ranking: {
              complete,
              incomplete,
              total,
              colorComplete: "#008908",
              colorIncomplete: "#E5E5E5",
            },
            Qtd: total,
            "%": percent,
            adhesionGoal: adhesionGoal,
            rawPercent: total ? complete / total : 0,
          };
        });
      }
    }

    const hasUpdatedTableData =
      !!updatedTableData && updatedTableData.length > 0;
    if (hasUpdatedTableData) {
      updatedTableData.sort((a, b) => {
        const isRawPercentEqual = b.rawPercent === a.rawPercent;
        if (isRawPercentEqual) {
          return b.Qtd - a.Qtd;
        }

        return b.rawPercent - a.rawPercent;
      });
    }

    return updatedTableData;
  }

  async function getTableDataSubqualifiers(
    formatedInitialDate,
    formatedFinalDate,
    unitsIds,
    businessId,
    idOfSubqualifier,
  ) {
    let dataToGenerateTable = null;
    const response = await getRankingSubqualifiers(
      formatedInitialDate,
      formatedFinalDate,
      unitsIds,
      businessId,
      idOfSubqualifier,
    );
    const hasResponse = !!response && response.status === 200;
    if (hasResponse) {
      const data = response.data;
      const hasData = !!data && data.length > 0;
      if (hasData) {
        dataToGenerateTable = data.map((datum) => {
          return {
            Unidade: datum.unidade,
            Ranking: {
              complete: 0,
              incomplete: 0,
              total: 0,
              colorComplete: "#C90000",
              colorIncomplete: "#E5E5E5",
            },
            Qtd: datum.qtde,
            rawQtd: Number(datum.qtde) ? Number(datum.qtde) : 0,
            "%": 200,
          };
        });
      }
    }

    let newDataToGenerateTable = dataToGenerateTable;
    const hasDataToGenerateTable =
      !!dataToGenerateTable && dataToGenerateTable.length > 0;
    if (hasDataToGenerateTable) {
      dataToGenerateTable.sort((a, b) => b.rawQtd - a.rawQtd);
      let maxQtd = 0;
      newDataToGenerateTable = dataToGenerateTable.map((tableData, index) => {
        const isFirstItem = index === 0;
        if (isFirstItem) {
          maxQtd = tableData.rawQtd;
        }

        const complete = tableData.rawQtd;
        const incomplete = maxQtd - complete;
        const total = complete + incomplete;
        tableData.Ranking.complete = complete;
        tableData.Ranking.incomplete = incomplete;
        tableData.Ranking.total = total;
        return tableData;
      });
    }
    return newDataToGenerateTable;
  }

  /*
  function handleTempMed(tempMed) {
    // ANO | MES | DIA | HORA | MINUTO | SEGUNDO
    const cutTime = tempMed.split("|");
    let ano = cutTime[0];
    let mes = cutTime[1];
    let dia = cutTime[2];
    let hora = cutTime[3];
    let minuto = cutTime[4];
    let segundo = cutTime[5];

    if (ano !== "0000") {
      return `${ano.replaceAll("0", "")} ano(s)`;
    } else if (mes !== "00") {
      const corrigirMeses = mes.replaceAll("0", "");
      return `${mes.replaceAll("0", "")} ${
        corrigirMeses > 1 ? "meses" : "mês"
      }`;
    } else if (dia !== "00") {
      return `${dia.replaceAll("0", "")} dia(s)`;
    } else if (hora !== "00") {
      return `${hora.replaceAll("0", "")} hora(s)`;
    } else if (minuto !== "00") {
      return `${minuto.replaceAll("0", "")} minuto(s)`;
    } else if (segundo !== "00") {
      return `${segundo.replaceAll("0", "")} segundo(s)`;
    }
  }
  */

  function handleTempMed(tempMed) {
    // ANO | MES | DIA | HORA | MINUTO | SEGUNDO
    const cutTime = tempMed.split("|");
    let ano = cutTime[0];
    let mes = cutTime[1];
    let dia = cutTime[2];
    let hora = cutTime[3];
    let minuto = cutTime[4];
    let segundo = cutTime[5];

    if (ano !== "0000") {
      return `${Number(ano)} ano(s)`;
    } else if (mes !== "00") {
      const corrigirMeses = Number(mes);
      return `${Number(mes)} ${corrigirMeses > 1 ? "meses" : "mês"}`;
    } else if (dia !== "00") {
      return `${Number(dia)} dia(s)`;
    } else if (hora !== "00") {
      return `${Number(hora)} hora(s)`;
    } else if (minuto !== "00") {
      return `${Number(minuto)} minuto(s)`;
    } else if (segundo !== "00") {
      return `${Number(segundo)} segundo(s)`;
    }
  }

  function getColorOfComplete(proportion) {
    const isProportionLessOrEqualThanOne = proportion <= 1;
    if (isProportionLessOrEqualThanOne) {
      return "#008908";
    }

    const percent = 100 / proportion;
    const isGreenZone = percent <= 100 && percent > 75;
    if (isGreenZone) {
      return "#008908";
    }

    const isYellowZone = percent <= 75 && percent > 50;
    if (isYellowZone) {
      return "#F2BD00";
    }

    return "#C90000";
  }

  const printContentV2 = async () => {
    const contentElement = document.getElementById("print-content");
    const pageElement = document.querySelector(".nps-page__content");
    const originalHeight = contentElement.style.height;

    contentElement.style.height = "auto";
    contentElement.style.overflow = "visible";
    pageElement.style.overflow = "visible";

    const offSetHeight = window.outerHeight - pageElement.offsetHeight + 200;
    await htmlToImage
      .toPng(contentElement, {
        height: pageElement.scrollHeight + offSetHeight,
      })
      .then(function (dataUrl) {
        const a = document.createElement("a");
        a.download = "qualidade-call-center_print.png";
        a.href = dataUrl;
        a.click();
        contentElement.style.height = originalHeight;
        contentElement.style.overflow = "auto";
        pageElement.style.overflow = "auto";
        // document.getElementById("border-line-container").style.display =  "block";
      })
      .catch(function (error) {
        console.error("oops, something went wrong!", error);
        contentElement.style.height = originalHeight;
        contentElement.style.overflow = "auto";
        pageElement.style.overflow = "auto";
      });
  };

  const printContent = async () => {
    const contentElement = document.getElementById("print-content");
    const pageElement = document.querySelector(".nps-page__content");
    const originalHeight = contentElement.style.height;

    contentElement.style.height = "auto";
    contentElement.style.overflow = "visible";
    pageElement.style.overflow = "visible";

    const isIndicatorsPage =
      activeButton === "IndicatorsAgent" && !!pageElement;

    if (isIndicatorsPage) {
      const offSetHeight = window.outerHeight - pageElement.offsetHeight + 200;
      await htmlToImage
        .toPng(contentElement, {
          height: pageElement.scrollHeight + offSetHeight,
        })
        .then(function (dataUrl) {
          const a = document.createElement("a");
          a.download = "NPS_print.png";
          a.href = dataUrl;
          a.click();
          contentElement.style.height = originalHeight;
          contentElement.style.overflow = "auto";
          pageElement.style.overflow = "auto";
          // document.getElementById("border-line-container").style.display =  "block";
        })
        .catch(function (error) {
          console.error("oops, something went wrong!", error);
          contentElement.style.height = originalHeight;
          contentElement.style.overflow = "auto";
          pageElement.style.overflow = "auto";
        });
    } else {
      await htmlToImage
        .toPng(contentElement, {
          height: window.outerHeight + window.innerHeight + 900,
        })
        .then(function (dataUrl) {
          const a = document.createElement("a");
          a.download = "NPS_print.png";
          a.href = dataUrl;
          a.click();
          contentElement.style.height = originalHeight;
          contentElement.style.overflow = "auto";
          pageElement.style.overflow = "auto";
          // document.getElementById("border-line-container").style.display =  "block";
        })
        .catch(function (error) {
          console.error("oops, something went wrong!", error);
          contentElement.style.height = originalHeight;
          contentElement.style.overflow = "auto";
          pageElement.style.overflow = "auto";
        });
    }
  };

  const getPopoverScreen = (id) => {
    switch (id) {
      case "DashboardAgent":
        return "dash-call-center";
      case "IndicatorsAgent":
        return "indicators-call-center";
      default:
        return "dash-call-center";
    }
  };

  const getMenuData = (id) => {
    switch (id) {
      case "DashboardAgent":
        return exhibCards;
      case "IndicatorsAgent":
        return exhibIndicatorsCards;
      default:
        return exhibCards;
    }
  };

  /*
  useEffect(() => {
    if (filtersDashboard && filtersDashboard.datestart) {
      setStartDate(filtersDashboard.datestart);
    }
    if (filtersDashboard && filtersDashboard.dateend) {
      setEndDate(filtersDashboard.dateend);
    }
    if (filtersDashboard && filtersDashboard.units) {
      setUnitsSelected(filtersDashboard.units);
    }
    if (filtersDashboard && filtersDashboard.business) {
      setBusinessSelected(filtersDashboard.business);
    }
  }, [filtersDashboard]);
*/

  useEffect(() => {
    if (agentDashboardFilter && agentDashboardFilter.initialDateAgenteScreen) {
      setStartDate(agentDashboardFilter.initialDateAgenteScreen);
    }
    if (agentDashboardFilter && agentDashboardFilter.finalDateAgentScreen) {
      setEndDate(agentDashboardFilter.finalDateAgentScreen);
    }
  }, [agentDashboardFilter]);
  return (
    <>
      <main id="print-content" className="nps-page-quality">
        <div
          style={{
            width: "100%",
            height: "328px",
            display: "none",
            position: "relative",
          }}
          ref={npsEvolutionRef}
        >
          <div
            style={{
              display: "none",
              position: "absolute",
              width: "100dvw",
              height: "100dvh",
              backgroundColor: "#fff",
              zIndex: 99,
              textAlign: "center",
            }}
            ref={loadingPdf}
          >
            <Loading.Paperplane />
            <Typography.H5 weight="700" color="gray-180">
              {loadingCount}
            </Typography.H5>
          </div>
          <div
            ref={toGeneratePdf}
            style={{
              width: "100%",
              fontFamily: "Arial, sans-serif",
              backgroundColor: "#FFFFFF",
              maxWidth: "1600px",
            }}
            className="nps-page-quality-pdf-generator"
          >
            <div
              ref={pdfPage1}
              style={{
                width: "100%",
                fontFamily: "Arial, sans-serif",
              }}
              className="nps-page-quality-pdf-generator"
            >
              <div
                ref={coverRef}
                className="nps-page-quality-pdf-generator__cover"
              >
                <div className="nps-page-quality-pdf-generator__cover__logo">
                  <img
                    alt="logo da empresa"
                    src={
                      connection_platform.companyLogoUrl
                        ? connection_platform.companyLogoUrl
                        : defaultCoverLogo
                    }
                  />
                </div>
                <div className="nps-page-quality-pdf-generator__cover__content">
                  <Typography.H1
                    weight="700"
                    className="nps-page-quality-pdf-generator__cover__content__title"
                  >
                    Relatório de Qualidade
                  </Typography.H1>
                  <span className="nps-page-quality-pdf-generator__cover__content__subtitle">{`Unidades: ${
                    hasUnits
                      ? unitsSelected.map((unit) => unit.label).join(", ")
                      : "Todas"
                  }`}</span>
                  <span className="nps-page-quality-pdf-generator__cover__content__subtitle">{`Período: ${
                    startDate ? format(new Date(startDate), "dd/MM/yyyy") : ""
                  } a ${
                    endDate ? format(new Date(endDate), "dd/MM/yyyy") : ""
                  }`}</span>
                </div>
              </div>

              {/*Analise geral*/}

              <div ref={generalAnalysisNpsRef}>
                <div className="nps-page-quality-pdf-generator__header nps-page-quality-pdf-generator__header-new-page">
                  <div className="nps-page-quality-pdf-generator__header__title">
                    <p className="nps-page-quality-pdf-generator__header__title__main">
                      Análise geral
                    </p>
                    <span>{`Período: ${
                      startDate ? format(new Date(startDate), "dd/MM/yyyy") : ""
                    } a ${
                      endDate ? format(new Date(endDate), "dd/MM/yyyy") : ""
                    }`}</span>
                  </div>
                  <div className="nps-page-quality-pdf-generator__header__logo">
                    <img
                      alt="logo da empresa"
                      src={
                        connection_platform.companyLogoUrl
                          ? connection_platform.companyLogoUrl
                          : defaultLogo
                      }
                    />
                  </div>
                </div>

                <div className="nps-page-quality-pdf-generator__survey-data">
                  {surveyData.map((data, index) => {
                    return (
                      <div key={index} className={`${data.classContainer}`}>
                        <div className={data.class}>
                          <span className={`${data.class}__icon`}>
                            {data.icon}
                          </span>

                          <span className={`${data.class}__text`}>
                            <Typography.H1
                              weight="700"
                              className={`${data.class}__text__number`}
                            >
                              {data.number}
                            </Typography.H1>

                            <Typography.H6
                              className={`${data.class}__text__information`}
                              weight="400"
                            >
                              {data.information}
                            </Typography.H6>
                          </span>
                        </div>
                      </div>
                    );
                  })}
                </div>

                <div
                  style={{ overflow: "hidden", width: "1500px" }}
                  className="nps-evolution nps-page-quality-pdf-generator__nps-evolution"
                >
                  <header className="nps-evolution-header">
                    <Typography.H5 weight="700" color="gray-180">
                      Evolução do NPS
                    </Typography.H5>

                    <div className="nps-evolution-header-tags">
                      <span className="nps-evolution-header-tags__span">
                        <div className="nps-evolution-original" />

                        <Typography.H5 weight="500" color="gray-180">
                          NPS Original
                        </Typography.H5>
                      </span>
                      <span className="nps-evolution-header-tags__span">
                        <div className="nps-evolution-treated" />

                        <Typography.H5 weight="500" color="gray-180">
                          NPS Tratado
                        </Typography.H5>
                      </span>
                      <span className="nps-evolution-header-tags__span">
                        <GoalIcon />

                        <Typography.H6 weight="500" color="gray-180">
                          {`Meta de ${metaValue}% `}
                        </Typography.H6>
                      </span>
                    </div>
                    <div className="nps-page-quality-pdf-generator__nps-evolution__empty"></div>
                  </header>

                  <div style={{ height: "423px", backgroundColor: "#ffffff" }}>
                    <ResponsiveContainer
                      width="100%"
                      height="106%"
                      style={{ backgroundColor: "#ffffff" }}
                    >
                      <ComposedChart data={dataEvo}>
                        <XAxis dataKey="name" tickFormatter={handleTime} />
                        <YAxis tick={<CustomYAxisTick />} />
                        <Tooltip content={<CustomTooltip />} />
                        <CartesianGrid stroke="#f5f5f5" />
                        <Bar
                          dataKey="npsO"
                          barSize={15}
                          fill="#C0CA33"
                          isAnimationActive={false}
                        />
                        <Bar
                          dataKey="npsT"
                          barSize={15}
                          fill="#455CC7"
                          isAnimationActive={false}
                        />
                        {/* <Area type="linear" dataKey="uv" fill="#b4bde8" stroke="#8884d8" /> */}
                        <Line
                          type="linear"
                          dataKey="meta"
                          stroke="#FFB300"
                          strokeWidth={2}
                          dot={false}
                          activeDot={false}
                          strokeDasharray="3 3"
                          isAnimationActive={false}
                        />
                      </ComposedChart>
                    </ResponsiveContainer>
                  </div>
                </div>
              </div>
              {/*CSAT */}

              <div ref={generalAnalysisCsatRef}>
                <div className="nps-page-quality-pdf-generator__header nps-page-quality-pdf-generator__header-new-page">
                  <div className="nps-page-quality-pdf-generator__header__title">
                    <p className="nps-page-quality-pdf-generator__header__title__main">
                      Análise geral
                    </p>
                    <span>{`Período: ${
                      startDate ? format(new Date(startDate), "dd/MM/yyyy") : ""
                    } a ${
                      endDate ? format(new Date(endDate), "dd/MM/yyyy") : ""
                    }`}</span>
                  </div>
                  <div className="nps-page-quality-pdf-generator__header__logo">
                    <img
                      alt="logo da empresa"
                      src={
                        connection_platform.companyLogoUrl
                          ? connection_platform.companyLogoUrl
                          : defaultLogo
                      }
                    />
                  </div>
                </div>

                <div
                  style={{ overflow: "hidden", width: "1500px" }}
                  className="nps-evolution nps-page-quality-pdf-generator__nps-evolution"
                >
                  <header className="nps-evolution-header">
                    <Typography.H5 weight="700" color="gray-180">
                      Evolução do CSAT
                    </Typography.H5>

                    <div className="nps-evolution-header-tags">
                      <span className="nps-evolution-header-tags__span">
                        <div className="nps-evolution-original" />

                        <Typography.H5 weight="500" color="gray-180">
                          CSAT Original
                        </Typography.H5>
                      </span>

                      <span className="nps-evolution-header-tags__span">
                        <div className="nps-evolution-treated" />

                        <Typography.H5 weight="500" color="gray-180">
                          CSAT Tratado
                        </Typography.H5>
                      </span>
                      <span className="nps-evolution-header-tags__span">
                        <GoalIcon />

                        <Typography.H6 weight="500" color="gray-180">
                          {`Meta de ${metaValue}% `}
                        </Typography.H6>
                      </span>
                    </div>
                    <div className="nps-page-quality-pdf-generator__nps-evolution__empty"></div>
                  </header>

                  <div style={{ height: "423px", backgroundColor: "#ffffff" }}>
                    <ResponsiveContainer
                      width="100%"
                      height="106%"
                      style={{ backgroundColor: "#ffffff" }}
                    >
                      <ComposedChart data={dataEvoCsat}>
                        <XAxis dataKey="name" tickFormatter={handleTime} />
                        <YAxis tick={<CustomYAxisTick />} />
                        <Tooltip content={<CustomTooltip />} />
                        <CartesianGrid stroke="#f5f5f5" />
                        <Bar
                          dataKey="npsO"
                          barSize={15}
                          fill="#1E88E5"
                          isAnimationActive={false}
                        />
                        <Bar
                          dataKey="npsT"
                          barSize={15}
                          fill="#455CC7"
                          isAnimationActive={false}
                        />
                        {/* <Area type="linear" dataKey="uv" fill="#b4bde8" stroke="#8884d8" /> */}
                        <Line
                          type="linear"
                          dataKey="meta"
                          stroke="#FFB300"
                          strokeWidth={2}
                          dot={false}
                          activeDot={false}
                          strokeDasharray="3 3"
                          isAnimationActive={false}
                        />
                      </ComposedChart>
                    </ResponsiveContainer>
                  </div>
                </div>
              </div>
              {/*Subqualificadores*/}
              <div ref={subqualifiersPageRef}>
                <div className="nps-page-quality-pdf-generator__header nps-page-quality-pdf-generator__header-new-page">
                  <div className="nps-page-quality-pdf-generator__header__title">
                    <p className="nps-page-quality-pdf-generator__header__title__main">
                      Subqualificadores
                    </p>
                    <span>{`Período: ${
                      startDate ? format(new Date(startDate), "dd/MM/yyyy") : ""
                    } a ${
                      endDate ? format(new Date(endDate), "dd/MM/yyyy") : ""
                    }`}</span>
                  </div>
                  <div className="nps-page-quality-pdf-generator__header__logo">
                    <img
                      alt="logo da empresa"
                      src={
                        connection_platform.companyLogoUrl
                          ? connection_platform.companyLogoUrl
                          : defaultLogo
                      }
                    />
                  </div>
                </div>

                {
                  <div
                    style={{
                      display: "flex",
                      alignItems: "flex-start",
                      gap: "20px",
                    }}
                  >
                    <div style={{ flex: 1 }}>
                      <HorizontalStackedChart
                        data={stackedDataTreatment}
                        subqualifiers={subqualifiersTreatment}
                      />
                    </div>
                    <div style={{ flex: 1 }}>
                      <HorizontalStackedChart
                        title="Estrutura"
                        subtitle="Subqualificadores de estrutura"
                        data={stackedDataStructure}
                        subqualifiers={subqualifiersStructure}
                      />
                    </div>
                    <div style={{ flex: 1 }}>
                      <HorizontalStackedChart
                        title="Serviço"
                        subtitle="Subqualificadores de serviço"
                        data={stackedDataService}
                        subqualifiers={subqualifiersService}
                      />
                    </div>
                  </div>
                }
              </div>

              {/*Tratativas*/}
              <div ref={negotiationsRef}>
                <div className="nps-page-quality-pdf-generator__header nps-page-quality-pdf-generator__header-new-page">
                  <div className="nps-page-quality-pdf-generator__header__title">
                    <p className="nps-page-quality-pdf-generator__header__title__main">
                      Tratativas
                    </p>
                    <span>{`Período: ${
                      startDate ? format(new Date(startDate), "dd/MM/yyyy") : ""
                    } a ${
                      endDate ? format(new Date(endDate), "dd/MM/yyyy") : ""
                    } - Pefil: ${profile}`}</span>
                  </div>
                  <div className="nps-page-quality-pdf-generator__header__logo">
                    <img
                      alt="logo da empresa"
                      src={
                        connection_platform.companyLogoUrl
                          ? connection_platform.companyLogoUrl
                          : defaultLogo
                      }
                    />
                  </div>
                </div>

                <div className="nps-page-quality-pdf-generator__current-negotiations">
                  <span className="nps-page-quality-pdf-generator__current-negotiations__title">{`Mês atual - Período:${currentMonthStart} a ${currentMonthEnd}`}</span>
                  <div className="nps-page-quality-pdf-generator__current-negotiations__content">
                    {currentNegotiations.map((data) => {
                      const isDiferrenceANumber =
                        typeof data.difference === "number";

                      const renderDifference = (diff) => {
                        const isDiferrenceANumber = typeof diff === "number";
                        if (isDiferrenceANumber) {
                          return diff.toFixed(2) + "%";
                        }
                        return "-";
                      };

                      const renderArrow = (diff) => {
                        const isDiffNumberAndPositive =
                          typeof diff === "number" && diff >= 0;
                        if (isDiffNumberAndPositive) {
                          return <ArrowUpIcon />;
                        }

                        const isDiffNotANumberButPositive =
                          typeof diff !== "number" && diff === "ꝏ";
                        if (isDiffNotANumberButPositive) {
                          return <ArrowUpIcon />;
                        }

                        return <ArrowDownIcon />;
                      };

                      return (
                        <div key={data.id} className={data.class}>
                          <div className="nps-page-quality-pdf-generator__current-negotiations__content__info">
                            <span className={`${data.class}__icon`}>
                              {data.icon}
                            </span>

                            <div>
                              <div className={`${data.class}__text`}>
                                <Typography.H1
                                  weight="700"
                                  className={`${data.class}__text__number`}
                                >
                                  {data.number}
                                </Typography.H1>

                                <Typography.H6
                                  className={`${data.class}__text__information`}
                                  weight="400"
                                >
                                  {data.information}
                                </Typography.H6>
                              </div>
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  paddingTop: "5px",
                                  gap: "8px",
                                }}
                              >
                                {renderArrow(data.difference)}
                                <span
                                  style={{
                                    color: `${
                                      data.difference >= 0 ||
                                      data.difference === "ꝏ"
                                        ? "#008908"
                                        : "#C90000"
                                    }`,
                                    display: "block",
                                  }}
                                >
                                  {renderDifference(data.difference)}
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>

                <div className="nps-page-quality-pdf-generator__last-negotiations">
                  <span className="nps-page-quality-pdf-generator__last-negotiations__title">{`Mês anterior - Período:${lastMonthStart} a ${lastMonthEnd}`}</span>
                  <div className="nps-page-quality-pdf-generator__last-negotiations__content">
                    {lastNegotitations.map((data) => (
                      <div key={data.id} className={data.class}>
                        <span className={`${data.class}__icon`}>
                          {data.icon}
                        </span>

                        <span className={`${data.class}__text`}>
                          <Typography.H1
                            weight="700"
                            className={`${data.class}__text__number`}
                          >
                            {data.number}
                          </Typography.H1>

                          <Typography.H6
                            className={`${data.class}__text__information`}
                            weight="400"
                          >
                            {data.information}
                          </Typography.H6>
                        </span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
            {/*Casos*/}
            <div
              ref={pdfPage2}
              style={{
                width: "100%",
                fontFamily: "Arial, sans-serif",
              }}
              className="nps-page-quality-pdf-generator"
            >
              <div ref={casesContainerRef}>
                <div className="nps-page-quality-pdf-generator__header">
                  <div className="nps-page-quality-pdf-generator__header__title">
                    <p className="nps-page-quality-pdf-generator__header__title__main">
                      Casos
                    </p>
                    <span>{`Período: ${
                      startDate ? format(new Date(startDate), "dd/MM/yyyy") : ""
                    } a ${
                      endDate ? format(new Date(endDate), "dd/MM/yyyy") : ""
                    }`}</span>
                  </div>
                  <div className="nps-page-quality-pdf-generator__header__logo">
                    <img
                      alt="logo da empresa"
                      src={
                        connection_platform.companyLogoUrl
                          ? connection_platform.companyLogoUrl
                          : defaultLogo
                      }
                    />
                  </div>
                </div>

                <div
                  ref={casesRef}
                  className="nps-page-quality-pdf-generator__cases1"
                ></div>
              </div>
              {/*Casos Reclamação*/}
              <div ref={casesComplaintContainerRef}>
                <div className="nps-page-quality-pdf-generator__header nps-page-quality-pdf-generator__header-new-page">
                  <div className="nps-page-quality-pdf-generator__header__title">
                    <p className="nps-page-quality-pdf-generator__header__title__main">{`Casos - ${caseTypeLabel}`}</p>
                    <span>{`Período: ${
                      startDate ? format(new Date(startDate), "dd/MM/yyyy") : ""
                    } a ${
                      endDate ? format(new Date(endDate), "dd/MM/yyyy") : ""
                    }`}</span>
                  </div>
                  <div className="nps-page-quality-pdf-generator__header__logo">
                    <img
                      alt="logo da empresa"
                      src={
                        connection_platform.companyLogoUrl
                          ? connection_platform.companyLogoUrl
                          : defaultLogo
                      }
                    />
                  </div>
                </div>

                <div
                  ref={casesComplaintRef}
                  className="nps-page-quality-pdf-generator__cases"
                ></div>
              </div>
            </div>
            {/*Ranking*/}
            <div
              ref={pdfPage3}
              style={{
                width: "100%",
                fontFamily: "Arial, sans-serif",
              }}
              className="nps-page-quality-pdf-generator"
            >
              <div ref={rankingNpsContainerRef}>
                <div className="nps-page-quality-pdf-generator__header">
                  <div className="nps-page-quality-pdf-generator__header__title">
                    <p className="nps-page-quality-pdf-generator__header__title__main">
                      Ranking NPS
                    </p>
                    <span>{`Período: ${
                      startDate ? format(new Date(startDate), "dd/MM/yyyy") : ""
                    } a ${
                      endDate ? format(new Date(endDate), "dd/MM/yyyy") : ""
                    }`}</span>
                  </div>
                  <div className="nps-page-quality-pdf-generator__header__logo">
                    <img
                      alt="logo da empresa"
                      src={
                        connection_platform.companyLogoUrl
                          ? connection_platform.companyLogoUrl
                          : defaultLogo
                      }
                    />
                  </div>
                </div>

                <div
                  ref={rankingNpsRef}
                  className="nps-page-quality-pdf-generator__ranking-nps"
                ></div>
              </div>

              {/*Ranking CSAT*/}
              <div ref={rankingCsatContainerRef}>
                <div className="nps-page-quality-pdf-generator__header nps-page-quality-pdf-generator__header-new-page">
                  <div className="nps-page-quality-pdf-generator__header__title">
                    <p className="nps-page-quality-pdf-generator__header__title__main">
                      Ranking CSAT
                    </p>
                    <span>{`Período: ${
                      startDate ? format(new Date(startDate), "dd/MM/yyyy") : ""
                    } a ${
                      endDate ? format(new Date(endDate), "dd/MM/yyyy") : ""
                    }`}</span>
                  </div>
                  <div className="nps-page-quality-pdf-generator__header__logo">
                    <img
                      alt="logo da empresa"
                      src={
                        connection_platform.companyLogoUrl
                          ? connection_platform.companyLogoUrl
                          : defaultLogo
                      }
                    />
                  </div>
                </div>

                <div
                  ref={rankingCsatRef}
                  className="nps-page-quality-pdf-generator__ranking-csat"
                ></div>
              </div>
            </div>
            {/*Ranking de Adesão*/}
            <div
              ref={pdfPage4}
              style={{
                width: "100%",
                fontFamily: "Arial, sans-serif",
              }}
              className="nps-page-quality-pdf-generator"
            >
              <div ref={rankingAccessionContainerRef}>
                <div className="nps-page-quality-pdf-generator__header">
                  <div className="nps-page-quality-pdf-generator__header__title">
                    <p className="nps-page-quality-pdf-generator__header__title__main">
                      Ranking de Adesão
                    </p>
                    <span>{`Período: ${
                      startDate ? format(new Date(startDate), "dd/MM/yyyy") : ""
                    } a ${
                      endDate ? format(new Date(endDate), "dd/MM/yyyy") : ""
                    }`}</span>
                  </div>
                  <div className="nps-page-quality-pdf-generator__header__logo">
                    <img
                      alt="logo da empresa"
                      src={
                        connection_platform.companyLogoUrl
                          ? connection_platform.companyLogoUrl
                          : defaultLogo
                      }
                    />
                  </div>
                </div>

                <div
                  ref={rankingAccessionRef}
                  className="nps-page-quality-pdf-generator__ranking-accession"
                ></div>
              </div>

              {/*Ranking Subqualificadores de Atendimento*/}

              <div ref={rankingSubqualifierContainerRef}>
                <div className="nps-page-quality-pdf-generator__header nps-page-quality-pdf-generator__header-new-page">
                  <div className="nps-page-quality-pdf-generator__header__title">
                    <p className="nps-page-quality-pdf-generator__header__title__main">{`Ranking Subqualificadores de ${subqualifierType}`}</p>
                    <span>{`Período: ${
                      startDate ? format(new Date(startDate), "dd/MM/yyyy") : ""
                    } a ${
                      endDate ? format(new Date(endDate), "dd/MM/yyyy") : ""
                    }`}</span>
                  </div>
                  <div className="nps-page-quality-pdf-generator__header__logo">
                    <img
                      alt="logo da empresa"
                      src={
                        connection_platform.companyLogoUrl
                          ? connection_platform.companyLogoUrl
                          : defaultLogo
                      }
                    />
                  </div>
                </div>

                <div
                  ref={rankingSubqualifierRef}
                  className="nps-page-quality-pdf-generator__ranking-subqualifier"
                ></div>
              </div>
            </div>

            {/*Ranking de Tratativas Concluídas*/}
            <div
              ref={pdfPage5}
              style={{
                width: "100%",
                fontFamily: "Arial, sans-serif",
              }}
              className="nps-page-quality-pdf-generator"
            >
              <div ref={rankingCompletedNegotiationsContainerRef}>
                <div className="nps-page-quality-pdf-generator__header">
                  <div className="nps-page-quality-pdf-generator__header__title">
                    <p className="nps-page-quality-pdf-generator__header__title__main">
                      Ranking de Tratativas Concluídas
                    </p>
                    <span>{`Período: ${
                      startDate ? format(new Date(startDate), "dd/MM/yyyy") : ""
                    } a ${
                      endDate ? format(new Date(endDate), "dd/MM/yyyy") : ""
                    }`}</span>
                  </div>
                  <div className="nps-page-quality-pdf-generator__header__logo">
                    <img
                      alt="logo da empresa"
                      src={
                        connection_platform.companyLogoUrl
                          ? connection_platform.companyLogoUrl
                          : defaultLogo
                      }
                    />
                  </div>
                </div>

                <div
                  ref={rankingCompletedNegotiationsRef}
                  className="nps-page-quality-pdf-generator__ranking-subqualifier"
                ></div>
              </div>

              {/*Ranking de Prazo Médio de Tratativas*/}

              <div ref={rankingMediumTermContainerRef}>
                <div className="nps-page-quality-pdf-generator__header nps-page-quality-pdf-generator__header-new-page">
                  <div className="nps-page-quality-pdf-generator__header__title">
                    <p className="nps-page-quality-pdf-generator__header__title__main">
                      Ranking de Prazo Médio de Tratativas
                    </p>
                    <span>{`Período: ${
                      startDate ? format(new Date(startDate), "dd/MM/yyyy") : ""
                    } a ${
                      endDate ? format(new Date(endDate), "dd/MM/yyyy") : ""
                    }`}</span>
                  </div>
                  <div className="nps-page-quality-pdf-generator__header__logo">
                    <img
                      alt="logo da empresa"
                      src={
                        connection_platform.companyLogoUrl
                          ? connection_platform.companyLogoUrl
                          : defaultLogo
                      }
                    />
                  </div>
                </div>

                <div
                  ref={rankingMediumTermRef}
                  className="nps-page-quality-pdf-generator__ranking-medium-term"
                ></div>
              </div>
            </div>
          </div>
        </div>
        <nav className="navigation-buttons">
          <div className="navigation-buttons__nav">
            <div className="navigation-buttons-content">
              {buttonData.map((button, index) => (
                <button
                  key={index}
                  className={`navigation-buttons-content__button ${
                    activeButton === button.componentName ? "active" : ""
                  }`}
                  onClick={() => handleButtonClick(button.componentName)}
                >
                  <div className="button-content">
                    {button.icon}

                    <h5
                      className={`button-content__h5 ${
                        activeButton === button.componentName && "active"
                      }`}
                    >
                      {button.text}
                    </h5>
                  </div>

                  {/* {activeButton === button.componentName && (
                                        <SublinhadoIcon />
                                    )} */}
                </button>
              ))}
            </div>
          </div>

          <div className="options-wrapper">
            <button
              className="options-wrapper__button"
              style={{ backgroundColor: "#f1f1f1" }}
            >
              <PrintIcon onClick={printContentV2} />
            </button>
            {hasFiltersOfGraphics && (
              <PopoverColumnsFilter
                className={"filters-columns"}
                placement="bottom-end"
                menuData={getMenuData(activeButton)}
                screen={getPopoverScreen(activeButton)}
                isReduceStringActive={isIndicatorsScreen ? true : false}
                headerText="Ocultar Gráficos"
              >
                <SettingsIcon />
              </PopoverColumnsFilter>
            )}
            <button
              className="options-wrapper__button"
              onClick={() => setFilters(!filters)}
            >
              <FilterAltIcon />
            </button>
          </div>
        </nav>

        <article className="nps-page__content">
          {activeButton === "DashboardAgent" && <DashboardAgent />}
          {activeButton === "DealingAgent" && <Dealing />}
          {activeButton === "RankingAgent" && <Rankings />}
          {activeButton === "IndicatorsAgent" && <Indicators />}
        </article>
      </main>

      <Drawer.CallCenterfilters
        isOpen={filters}
        onClose={() => setFilters(!filters)}
        screen={activeButton}
      />
    </>
  );
};

export default QualityAgent;
